export default "__VITE_ASSET__BM9M16Nk__"